import classNames from 'classnames'
import { FC } from 'react'
import { Band } from 'src/services/aiListeningApi/brandProfile.types'
import styles from './charts.module.scss'

interface MeterBarProps {
  // Colour by band (purple / grey / orange); omitted = purple.
  band?: Band | null
  className?: string
  // Fill colour override (e.g. a domain's citation type).
  color?: string
  // Dotted guide lines at these values, labelled above the track.
  ticks?: number[]
  // 0–100
  value: number | null
}

const BAND_COLORS: Record<Band, string> = {
  attention: '#ff6833',
  moderate: '#c7ced1',
  strong: '#8080ff',
}

export const MeterBar: FC<MeterBarProps> = ({
  band,
  className,
  color,
  ticks,
  value,
}) => {
  const width = value === null ? 0 : Math.max(0, Math.min(100, value))
  const fill = color ?? (band ? BAND_COLORS[band] : BAND_COLORS.strong)

  return (
    <div
      className={classNames(styles.meter, className, {
        [styles.meterWithTicks]: !!ticks?.length,
      })}
    >
      <div className={styles.meterTrack}>
        <span
          className={styles.meterFill}
          style={{ background: fill, width: `${width}%` }}
        />
      </div>
      {ticks?.map((tick) => (
        <span
          className={styles.meterTick}
          key={tick}
          style={{ left: `${tick}%` }}
        >
          <span className={styles.meterTickLabel}>{tick}</span>
        </span>
      ))}
    </div>
  )
}
